export default {
  en: {
    wordLabel: 'Word',
    wordRequired: 'Enter a word',
    translationLabel: 'Translation',
    translationRequired: 'Enter a translation',
    fill: 'Fill in',
    transcriptionLabel: 'Transcription',
    exampleLabel: 'Example in English',
    exampleTranslationLabel: 'Example in Russian',
  },
  ru: {
    wordLabel: 'Слово',
    wordRequired: 'Введите слово',
    translationLabel: 'Перевод',
    translationRequired: 'Введите перевод',
    fill: 'Заполнить',
    transcriptionLabel: 'Транскрипция',
    exampleLabel: 'Пример на английском',
    exampleTranslationLabel: 'Пример на русском',
  },
};
